import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Goals',
      type: 'table',
      // NOTE: refetches this widget's data after the 'touch-and-open-
      // assistant' action actually executes on the backend, so the mutated
      // 'descr' value is reflected back here.
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'playground.touch-and-open-assistant',
            },
          },
        ],
      },
      content: {
        '{}': {
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  direct: {
                    '{}': {
                      name: 'Code',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'descr',
                  direct: {
                    '{}': {
                      name: 'Description',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
          query: {
            '`': {
              target: 'ent:!outcomes:!goal',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      descr: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                    },
                  },
                  // NOTE: clicking a row actually executes a real backend
                  // action - a DMS mutation that marks this Goal as
                  // "reviewed" - and then, as part of the same combined
                  // action, opens the assistant slideout authorized to
                  // retrieve exactly this row's (now-updated) record. This is
                  // the "row-click-driven" / dynamic counterpart to the
                  // fixed/static action on the 'open-assistant-metric' widget.
                  onClick: {
                    '{}': {
                      action: {
                        '{}': {
                          alias: 'playground.touch-and-open-assistant',
                        },
                      },
                      variables: {
                        '{}': {
                          goalId: { '@.': '!id' },
                        },
                      },
                    },
                  },
                },
              },
              sort: {
                by: { '@.': '!code' },
              },
            },
          },
          count: {
            '`': {
              selection: { '#': { '@': 'records' } },
              subqueries: {
                records: {
                  target: 'ent:!outcomes:!goal',
                },
              },
            },
          },
        },
      },
    },
  },
  sort: {
    by: { '@.': '!code' },
  },
}
